






































































































import { Component, Vue } from 'vue-property-decorator'
import { DayItem, generateEmptyDayItem } from '../models'
import { lazySrc } from '@/assets/imageSources'
import { Route } from 'vue-router'

@Component
export default class ReadDayItem extends Vue {
  private lazySrc: string = lazySrc
  private dayItem: DayItem = generateEmptyDayItem()
  private isLoading: boolean = false
  private hasPlayed: boolean = false
  private isPlaying: boolean = false
  private isWaiting: boolean = true
  private seek: Number = 0

  // state
  get dayItems (): DayItem[] {
    return this.$store.state.dayItems.all
  }

  get previousDayItem (): DayItem | null {
    return this.$store.state.dayItems.previous
  }

  get nextDayItem (): DayItem | null {
    return this.$store.state.dayItems.next
  }

  // lifecycle
  mounted () {
    const { id } = this.$route.params

    this.readDayItem(id)
  }

  beforeDestroy () {
    const audio = this.getAudioRef()

    audio.pause()

    this.detachAudioHandlers()
  }

  beforeRouteUpdate (to: Route, from: Route, next: Function) {
    const play = this.isPlaying || false

    this.detachAudioHandlers()
    this.readDayItem(to.params.id, play)

    next()
  }

  // handlers
  onWaiting () {
    this.isWaiting = true
  }

  onCanPlay () {
    this.isWaiting = false
  }

  onPlayClick () {
    this.getAudioRef().play()
  }

  onPlaying () {
    this.isPlaying = true
    this.hasPlayed = true
  }

  onPauseClick () {
    this.getAudioRef().pause()
  }

  onPause () {
    this.isPlaying = false
  }

  onEnded () {
    const { autoplay } = this.$store.state.transport

    if (autoplay) {
      // mark state so that player will start after skip
      this.isPlaying = true

      this.onNextClick()
    } else {
      this.isPlaying = false
      this.hasPlayed = false
      this.seek = 0
    }
  }

  onTimeUpdate () {
    const audio = this.getAudioRef()

    if (!this.isWaiting) {
      this.seek = (audio.currentTime / audio.duration) * 100
    }
  }

  onPreviousClick () {
    if (this.previousDayItem) {
      const { id } = this.previousDayItem

      this.$router.push({ name: 'readDayItem', params: { id } })
    }
  }

  onNextClick () {
    if (this.nextDayItem) {
      const { id } = this.nextDayItem

      this.$router.push({ name: 'readDayItem', params: { id } })
    }
  }

  attachAudioHandlers () {
    const audio = this.getAudioRef()

    audio.onplaying = this.onPlaying
    audio.onpause = this.onPause
    audio.onended = this.onEnded
    audio.ontimeupdate = this.onTimeUpdate
    audio.onwaiting = this.onWaiting
    audio.oncanplay = this.onCanPlay
  }

  detachAudioHandlers () {
    const audio = this.getAudioRef()

    audio.onplaying = null
    audio.onpause = null
    audio.onended = null
    audio.ontimeupdate = null
    audio.onwaiting = null
    audio.oncanplay = null
  }

  // helpers
  async readDayItem (id: string, play = false) {
    this.isLoading = true

    if (!this.dayItems.length) {
      await this.$store.dispatch('readDayItems')
    }

    try {
      this.dayItem = this.$store.getters.findDayItemById(id)
      this.$store.commit('selectDayItem', this.dayItem)

      this.$nextTick(function () {
        this.attachAudioHandlers()

        if (play) {
          this.onPlayClick()
        }
      })
    } catch (e) {
      // TODO message bus?
      console.error('Read Post Error:', e)
    }

    // reset player
    this.hasPlayed = false
    this.isPlaying = false
    this.isWaiting = true
    this.seek = 0

    this.isLoading = false
  }

  getAudioRef () {
    return (this.$refs.audio as HTMLAudioElement)
  }
}
